import { ApolloCache } from "@apollo/client";
import { TemplatesResponse } from "../typesDefinition";
import { UpdateCachedEntities } from "@/helpers/cache/typesDefinition";
import { Milestone } from "@26lights/orcha";
import { GET_TEMPLATES } from "@/graphql/orcha/templates/queries";
import { orderedComparator } from "@/helpers/orcha/utils";

export function updateMilestoneCache(
  cache: ApolloCache<TemplatesResponse>,
  templateId: string,
  phaseId: string,
  newItem: Milestone,
  updateCachedEntities: UpdateCachedEntities<Milestone>,
): void {
  const graphQLResponse: TemplatesResponse | null = cache.readQuery({
    query: GET_TEMPLATES,
  });

  if (graphQLResponse) {
    const templates = graphQLResponse.templates;

    const updatedTemplates = templates.map((t) => {
      if (t.id !== templateId) {
        return t;
      }
      return {
        ...t,
        phases: t.phases.map((ph) => {
          if (ph.id !== phaseId) {
            return ph;
          }
          return {
            ...ph,
            milestones: updateCachedEntities(
              newItem,
              ph.milestones,
              orderedComparator,
            ),
          };
        }),
      };
    });

    console.log({ newItem, updatedTemplates });

    cache.writeQuery({
      query: GET_TEMPLATES,
      data: {
        templates: updatedTemplates,
      },
    });
  }
}
